import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective } from 'ngx-mask';
import { DirectSalesThankYouPageComponent } from './direct-sales-thank-you-page/direct-sales-thank-you-page.component';
import { EmbeddedIdvWithOnfidoComponent } from './embedded-idv-with-onfido/embedded-idv-with-onfido.component';
import { IdentityVerifiedComponent } from './identity-verified/identity-verified.component';
import { InternalUserIdentityVerifiedComponent } from './internal-user-identity-verified/internal-user-identity-verified.component';
import { InternalUserIdvComponent } from './internal-user-idv/internal-user-idv.component';
import { StaticPagesRoutingModule } from './static-pages-routing.module';
import { StaticPreIdvPageComponent } from './static-pre-idv-page/static-pre-idv-page.component';


@NgModule({
    declarations: [
        StaticPreIdvPageComponent,
        EmbeddedIdvWithOnfidoComponent,
        IdentityVerifiedComponent,
        DirectSalesThankYouPageComponent,
        InternalUserIdvComponent,
        InternalUserIdentityVerifiedComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StaticPagesRoutingModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgxMaskDirective
    ]
})
export class StaticPagesModule { }
